import { useQuery } from '@tanstack/react-query'
import { TemplatesApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

/** ひな形の選択肢。id と name だけの軽量一覧 */
export const useQueryTaskScheduleTemplates = () =>
  useQuery({
    queryKey: queryKeys.templates,
    queryFn: () => baseClient.getApi(TemplatesApi).listTemplates(),
    select: data => data.templates.map(t => ({ id: t.id, name: t.name })),
    // 画面を二回目以降に開く際に、時間差でデータが更新されることによる事故を防ぐため
    gcTime: 0,
  })
